import { launchedFromMax, loadMaxBridge } from './maxBridge'

export const TELEGRAM_BRIDGE_URL = 'https://telegram.org/js/telegram-web-app.js'

/** Load only the current messenger's SDK before the first render. */
export function loadMiniAppBridge(win: Window = window, timeoutMs = 5000): Promise<void> {
  if (launchedFromMax(win) || (win as Window & { WebApp?: unknown }).WebApp) {
    return loadMaxBridge(win, timeoutMs)
  }
  if (win.Telegram?.WebApp) return Promise.resolve()

  return new Promise((resolve, reject) => {
    const script = win.document.createElement('script')
    const finish = (error?: Error) => {
      win.clearTimeout(timer)
      script.onload = null
      script.onerror = null
      if (error) {
        script.remove()
        reject(error)
      } else {
        resolve()
      }
    }
    const timer = win.setTimeout(() => finish(new Error('Telegram SDK timeout')), timeoutMs)
    script.src = TELEGRAM_BRIDGE_URL
    script.onload = () => finish(win.Telegram?.WebApp ? undefined : new Error('Telegram SDK unavailable'))
    script.onerror = () => finish(new Error('Telegram SDK failed to load'))
    win.document.head.appendChild(script)
  })
}
